import { isValidYoutubeVideoId } from '../shared/youtube';

/**
 * srcdoc 軽量 embed → YouTube embed 差し替え。
 * iframe の srcdoc 内の再生ボタンクリックで postMessage('playYT-{videoId}') が飛ぶ。
 * それを受けて srcdoc を除去し、src に本物の embed URL を設定する。
 */
export function initYoutubePlayer(): void {
  window.addEventListener('message', (e) => {
    if (e.origin !== window.location.origin) return;
    if (typeof e.data !== 'string' || !e.data.startsWith('playYT-')) return;
    const videoId = e.data.slice('playYT-'.length);
    if (!isValidYoutubeVideoId(videoId)) return;
    const iframe = Array.from(document.querySelectorAll<HTMLIFrameElement>('iframe[data-youtube-id]')).find(
      (candidate) => candidate.dataset.youtubeId === videoId && candidate.contentWindow === e.source,
    );
    if (!iframe) return;
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    iframe.removeAttribute('srcdoc');
  });
}
